/* eslint-disable no-restricted-globals */
import { Vec2, Vec3, Vec4 } from "../../../models/SyntheticMap";
import { CameraPosition } from "../../../visuals/visual-structs";
import { copyVec3 } from "../../../visuals/visual-utils";
import { PhysXObject } from "./PhysXObject";
import { PhysXScene } from "./PhysXScene";
import * as THREE from "three";
export const workerName = "PhysXWorker";
let scene: PhysXScene;
export class PhysXHandler {
  init(message: PWMessageInitResize) {
    scene = new PhysXScene(this);
    const { x, y } = message.data;
    scene.setSize(x, y);
    this.postMessageToMain({ type: PWMessageType.READY });
  }
  resize(message: PWMessageInitResize) {
    const { x, y } = message.data;
    scene.setSize(x, y);
  }
  cameraUpdate(message: PWCameraUpdate) {
    const { position, target: lookAt, up } = message;
    copyVec3(position, scene.camera.position);
    // const cameraNormal = new THREE.Vector3(0, 0, -1);
    // copyVec4(quaternion, scene.camera.quaternion);
    copyVec3(up, scene.camera.up);
    scene.camera.lookAt(new THREE.Vector3(lookAt.x, lookAt.y, lookAt.z));
    scene.camera.updateProjectionMatrix();
  }
  postMessageToMain<T extends PWMessage>(message: T) {
    self.postMessage(message);
  }
  objectsReplace(message: PWMessageObjects) {
    const objects = message.objects;
    scene.replaceObjects(objects);
  }
  objectsUpdate(message: PWMessageObjects) {
    const objects = message.objects;
    // console.log("Updating objects in PhysXWorker", objects);
    scene.updateObjects(objects);
  }
  test(message: PWMessage) {
    this.postMessageToMain({ type: PWMessageType.TEST });
  }
};

const handler = new PhysXHandler();

export function postMessageToMain<T extends PWMessage>(message: T) {
  // console.log(message);
  handler.postMessageToMain(message);
}

const handlerAny = handler as any;
self.onmessage = (event) => {
  try {
    const message: PWMessage = event.data;
    if (handlerAny[message.type]) {
      handlerAny[message.type](message);
      // console.log(`PhysXWorker handled message of type: ${message.type}`);
    }
  } catch (error) {
    console.error("Error in PhysXWorker onmessage handler:", error);
    self.postMessage({ type: PWMessageType.ERROR, error: `${error}` });
  }
};

export enum PWMessageType {
  INIT = 'init',
  RESIZE = 'resize',
  READY = 'ready',
  TEST = 'test',
  CAMERA_UPDATE = 'cameraUpdate',
  OBJECTS_REPLACE = 'objectsReplace',
  OBJECTS_UPDATE = 'objectsUpdate',
  DATA_UPDATE = 'dataUpdate',
  SCREEN_POS_UPDATE = 'screenPosUpdate',
  ERROR = 'error',
}

export interface PWMessage {
  type: PWMessageType;
}

export interface PWMessageInitResize extends PWMessage {
  data: Vec2; // Contains width and height
}

export interface PWCameraUpdate extends PWMessage, CameraPosition {
}

export type PWHandlerSync = {
  [K in PWMessageType]: (message: PWMessage) => void;
};

export interface PWMessageObjects extends PWMessage {
  objects: PhysXObject[];
}

export interface PWScreenPosUpdate extends PWMessage {
  changes: ScreePosUpdate[];
}

export interface PWMessageDataUpdate extends PWMessage {
  path: string;
  data: any;
}

export interface ScreePosUpdate {
  _id: string;
  position?: Vec2;
}

